import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-field-with-label',
	templateUrl: './field-with-label.component.html',
	styleUrls: ['./field-with-label.component.scss'],
})
export class FieldWithLabelComponent {
	@Input('label') label: string = '';
	@Input('required') required: boolean = false;
	@Input('title') title: string = '';
}
